import {
    Business,
    CreditCard,
    AttachMoney,
    AccountBalanceWallet,
  } from '@material-ui/icons';

export const menuHome = [
    { name: 'Cadastro de empresas', to: '/company'      , icon: <Business/>},
    { name: 'Antecipação',          to: '/anticipation' , icon: <CreditCard/>},
    { name: 'Pagamentos',           to: '/payments'     , icon: <AttachMoney/>},
    { name: 'Recebimentos',         to: '/receipts'     , icon: <AccountBalanceWallet/>},
  ];

 